import { Colors } from "@/theme";
import Image from "next/image";
import styled from "styled-components";
import { Body } from "../ui/typography/Body";

/**
 * Types
 */

interface ItemProps {
  title: string;
  description: string;
  icon: string;
}

/**
 * Styled Components
 */

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
`;

const Icon = styled(Image)`
  width: 24px;
  height: 24px;
  align-self: flex-start;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Title = styled(Body)`
  font-size: 16px;
  line-height: 24px;
`;

const Description = styled(Body)`
  font-size: 16px;
  font-weight: 400;
  color: ${Colors.gray400};
`;

/**
 * Item Component
 */
export const Item = ({ title, description, icon }: ItemProps) => (
  <Container>
    <Icon src={icon} alt={title} width={48} height={48} />
    <TextContainer>
      <Title text={title} variant="bold" color={Colors.black} size="medium" />
      <Description
        text={description}
        variant="regular"
        color={Colors.gray400}
        size="small"
      />
    </TextContainer>
  </Container>
);
